import { DealsListScreenContent } from "../../features/deals";

function DealsListScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <DealsListScreenContent />
      </div>
    </section>
  );
}

export default DealsListScreen;
